import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Address } from 'src/app/models/Address';
import { Employee } from 'src/app/models/Employees';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit {
  @Output() closePopup = new EventEmitter();
  @Input() address: Address = new Address();
  constructor() { }

  ngOnInit() { }

}
